module.exports = __webpack_public_path__ + "static/media/mainbg.7326f590.jpg";